<div class="chat-qual" [class.chat-qual--done]="answered">
  <div class="chat-qual__head">
    <span class="chat-qual__icon"><chat-icon name="help" [size]="15"></chat-icon></span>
    <span class="chat-qual__title">{{ strings.qualificationTitle }}</span>
  </div>
  <p *ngIf="!answered" class="chat-qual__text">{{ strings.qualificationText }}</p>
  <div *ngIf="!answered" class="chat-qual__preview">
    <div *ngFor="let q of preview" class="chat-qual__q">
      <span class="chat-qual__q-label">{{ q.label }}</span>
      <span class="chat-qual__fields"><span *ngFor="let o of q.options" class="chat-qual__field">{{ o }}</span></span>
    </div>
  </div>
  <dl *ngIf="answered && rows.length > 0" class="chat-qual__rows">
    <div *ngFor="let r of rows" class="chat-qual__row">
      <dt>{{ r.label }}</dt>
      <dd>{{ r.value }}</dd>
    </div>
  </dl>
  <div class="chat-qual__status" [class.chat-qual__status--ok]="answered">{{ statusText }}</div>
  <div *ngIf="canManage" class="chat-qual__actions">
    <button type="button" class="chat-qual__btn" (click)="edit.emit()">{{ answered ? strings.qualificationEdit : strings.qualAnswerForClient }}</button>
    <button *ngIf="answered" type="button" class="chat-qual__btn chat-qual__btn--primary" (click)="search.emit()">
      <chat-icon name="search" [size]="13"></chat-icon>{{ strings.qualificationSearch }}
    </button>
  </div>
</div>
